import { render } from "./ForgotPassView.vue?vue&type=template&id=f528a708&ts=true"
import script from "./ForgotPassView.vue?vue&type=script&lang=ts"
export * from "./ForgotPassView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__